import { Route } from "routes";
import { getRoutesForPath } from "./getRoutesForPath";

export const getBreadcrumbs = (pathname: string): Route[] => {
	const items = getRoutesForPath(pathname.split("/"));
	return items.length === 1 ? items : items.splice(1);
};
